import { useEffect, useState } from "react";
import InputField from "../../../components/Forms/InputField";
import MediaUpload from "../../../components/Forms/MediaUpload";
import RichTextEditor from "../../../components/Forms/RichTextEditor";
import { FaPlus, FaTrash } from "react-icons/fa";
import 'react-quill/dist/quill.snow.css';

const SubmissionType = ({
    type, active,
    questionData,
    correctDate, setCorrectDate,
    dropdownValues, setDropdownValues,
    verificationRequired, setVerificationRequired,
    submissionRequired, setSubmissionRequired,
    verificationType, setVerificationType,
    question, setQuestion,
    answerLimit, setAnswerLimit,
    mcqOptions, setMcqOptions,
    title, setTitle,
    mediaType, setMediaType,
    maxMediaUploadCount, setMaxMediaUploadCount,
    maxMediaUploadSize, setMaxMediaUploadSize,
    selfImageRequired, setSelfImageRequired,
    description,
    setDescription,
    sponsored, setSponsored,
    selfImageNotPresentPenaltyPoints, setselfImageNotPresentPenaltyPoints,
    withoutSelfImagePoints, setWithoutSelfImagePoints,
    videoSubmissionPoints, setVideoSubmissionPoints,
    points, setPoints,
    bonusPoints, setBonusPoints,
    image, setImage,
    stateImage, setStateImage,
    correctMCQAnswer, setCorrectMCQAnswer,
    calculateTotalPoints
}) => {

    const addDropDown = () => {
        if (dropdownValues.length < 10) {
            setDropdownValues([...dropdownValues, { value: '', correctAnswer: false }]);
        }
    };

    const updateDropDownValue = (index, value) => {
        const updatedDropdownValues = [...dropdownValues];
        updatedDropdownValues[index].value = value;
        setDropdownValues(updatedDropdownValues);
    };

    const updateDropDownCorrectAnswer = (index) => {
        const updatedDropdownValues = [...dropdownValues];
        updatedDropdownValues[index].correctAnswer = !updatedDropdownValues[index].correctAnswer;
        setDropdownValues(updatedDropdownValues);
    };

    const removeDropDown = (index) => {
        const updatedDropdownValues = [...dropdownValues];
        updatedDropdownValues.splice(index, 1);
        setDropdownValues(updatedDropdownValues);
    };

    const addOption = () => {
        if (mcqOptions.length < 4) setMcqOptions([...mcqOptions, { value: '', correct: false }]);
    };

    const updateOptionValue = (index, value) => {
        const updatedOptions = [...mcqOptions];
        updatedOptions[index].value = value;
        setMcqOptions(updatedOptions);
    };

    const updateCorrectOption = (index) => {
        const updatedOptions = mcqOptions.map((option, i) => ({
            ...option,
            correct: i === index
        }));
        setMcqOptions(updatedOptions);
        setCorrectMCQAnswer(index);
    };

    const removeOption = (index) => {
        const updatedOptions = [...mcqOptions];
        updatedOptions.splice(index, 1);
        setMcqOptions(updatedOptions);
    };

    useEffect(() => {
        setAnswerLimit(answerLimit);
        setQuestion(question);
        setCorrectDate(correctDate);
        setMcqOptions(mcqOptions);
        setDropdownValues(dropdownValues);
        setVerificationRequired(verificationRequired);
        setVerificationType(verificationType);
        setSubmissionRequired(submissionRequired);
    }, [answerLimit, question, mcqOptions, dropdownValues, correctDate]);

    useEffect(() => {
        !maxMediaUploadSize && setMaxMediaUploadSize(mediaType === 'video' ? "50" : "10");
        !points && setPoints(type === 'media' ? mediaType === 'video' ? "200" : "100" : "");
    }, [mediaType]);

    if (type === 'date') {
        return (
            <div className="flex gap-3">
                <div className='mt-3 basis-1/2'>
                    <RichTextEditor
                        label="Question"
                        placeholder={'Enter Question'}
                        value={question}
                        onChange={setQuestion}
                    />
                </div>
                <div className='mt-4 basis-1/2'>
                    <InputField
                        label={'Correct Answer'}
                        name={'correctDate'}
                        placeholder={'Enter Correct Answer'}
                        value={correctDate}
                        type={'date'}
                        onChange={e => {
                            setCorrectDate(e.target.value);
                        }}
                    />
                </div>
            </div>
        );
    }
    else if (type === 'description') {
        return (
            <div className="flex gap-2">
                <div className='mt-3 basis-1/2'>
                    <RichTextEditor
                        label="Question"
                        value={question}
                        onChange={setQuestion}
                    />
                </div>
                <div className='mt-4 basis-1/2'>
                    <InputField
                        label={'Answer’s Maximum Character Limit'}
                        placeholder={'Set Answer’s Maximum Character Limit'}
                        name={'answerLimit'}
                        value={answerLimit}
                        type={'number'}
                        onChange={e => setAnswerLimit(e.target.value)}
                    />
                </div>
            </div>
        );
    }
    else if (type === 'dropdown') {
        return (
            <div className="flex gap-3">
                <div className='mt-5 basis-1/2'>
                    <RichTextEditor
                        label="Question"
                        value={question}
                        onChange={setQuestion}
                    />
                </div>
                <div className='mt-0 bg-white p-3 basis-1/2'>
                    <div className="flex justify-between items-center pr-1">
                        <div className="text-base font-semibold my-2">Drop down Items (Max 10)</div>
                        <button onClick={addDropDown} className="flex items-center justify-center rounded-md p-1" type="button">
                            <FaPlus />
                        </button>
                    </div>
                    <table className="table border-collapse w-full text-base">
                        <thead className="bg-navBtn py-2">
                            <tr>
                                <th className="text-left">Srl. No.</th>
                                <th className="text-left">Dropdown Items</th>
                                <th className="text-center">Correct Answer</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dropdownValues.map((item, index) => (
                                    <tr key={index} >
                                        <td className="text-left">{index + 1}</td>
                                        <td className="text-left">
                                            <div className="flex gap-2.5 items-center px-4 py-1.5 mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                                <input type="text" value={item.value} placeholder={`Dropdown Item-${index + 1}`} onChange={e => updateDropDownValue(index, e.target.value)} className="w-full outline-none" />
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <input type="checkbox" checked={item.correctAnswer} onChange={() => updateDropDownCorrectAnswer(index)} />
                                        </td>
                                        <td className="basis-1/5 text-center">
                                            <button type="button" className="text-red" onClick={() => removeDropDown(index)}>
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
    else if (type === 'mcq') {
        return (
            <div>
                <div className='mt-5'>
                    <RichTextEditor
                        label="Question"
                        value={question}
                        onChange={setQuestion}
                    />
                </div>
                <div className="flex justify-between items-center pr-1 mt-0">
                    <div className="text-base font-semibold my-2">Options</div>
                    <button onClick={addOption} className="flex items-center justify-center rounded-md p-1" type="button">
                        <FaPlus />
                    </button>
                </div>
                <table className="w-full text-base">
                    <thead>
                        <tr className="flex flex-grow bg-navBtn py-2 rounded">
                            <th className="basis-1/5">Srl. No.</th>
                            <th className="basis-7/12">Option</th>
                            <th className="basis-1/5">Correct Answer</th>
                            <th className="basis-1/5">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            mcqOptions?.map((option, index) => (
                                <tr key={option._id} className="flex flex-grow py-2 items-center border-b border-navBtn">
                                    <td className="basis-1/5 text-center">{index + 1}</td>
                                    <td className="basis-7/12">
                                        <div className="flex gap-2.5 items-center px-4 py-2.5 mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                            <input type="text" value={option.value} placeholder={`Option-${index + 1}`} onChange={e => updateOptionValue(index, e.target.value)} className="w-full outline-none" />
                                        </div>
                                    </td>
                                    <td className="basis-1/5 text-center">
                                        <input type="radio" name="correctOption" checked={option.correctAnswer} onChange={() => updateCorrectOption(index)} />
                                    </td>
                                    <td className="basis-1/5 text-center">
                                        <button type="button" className="text-red" onClick={() => removeOption(index)}>
                                            <FaTrash />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        );
    }
    else if (type === 'media') {
        calculateTotalPoints();
        return (
            <div>
                <div className="flex flex-grow gap-3">
                    <div className="flex gap-2 w-full">
                        <div className="mt-2 basis-1/4">
                            <InputField
                                label={'Title'}
                                value={title || ''}
                                onChange={e => setTitle(e.target.value)}
                                placeholder={'Enter Media Title'}
                                type={'text'}
                                required={active}
                            />
                        </div>
                        <div className="mt-2 basis-1/4">
                            <InputField
                                label={'Select Media Type'}
                                value={mediaType || ''}
                                placeholder={'Select Media Type'}
                                onChange={e => {
                                    setMediaType(e.target.value);
                                    setMaxMediaUploadSize(e.target.value === 'video' ? "50" : "10");
                                }}
                                type={'select'}
                                required={active}
                                data={[
                                    { value: 'image', placeholder: 'Image' },
                                    { value: 'video', placeholder: 'Video' },
                                ]}
                            />
                        </div>
                        <div className="mt-2 basis-1/4">
                            <InputField
                                label={'Maximum Count Of Upload'}
                                placeholder={'Enter Maximum Count Of Upload'}
                                value={maxMediaUploadCount || ''}
                                name={'maxMediaUploadCount'}
                                onChange={e => setMaxMediaUploadCount(e.target.value)}
                                type={'number'}
                                required={active}
                            />
                        </div>
                        <div className="mt-2 basis-1/4">
                            <InputField
                                label={'Max Size Per Upload In MB'}
                                placeholder={'Enter Max Size Per Upload In MB'}
                                name={'maxMediaUploadSize'}
                                value={maxMediaUploadSize}
                                onChange={e => setMaxMediaUploadSize(e.target.value)}
                                type={'number'}
                                required={active}
                            />
                        </div>
                    </div>
                </div>
                <div className='flex justify-between gap-3 mt-5'>
                    <div className="h-full basis-1/2">
                        <MediaUpload
                            id="question-media-upload"
                            existingImage={image}
                            setImageUpload={setImage}
                            stateImage={stateImage}
                            setStateImageUpload={setStateImage}
                            label={'Add Sample Media'}
                            image={image}
                            setImage={setImage}
                            className={'w-full h-full'}
                            imgClassName={'w-full'}
                        />
                    </div>
                    <div className="w-full h-full basis-1/2">
                        <RichTextEditor
                            label="Description"
                            value={description || ''}
                            onChange={setDescription}
                            placeholder={'Enter Description'}
                            styles={{ height: '100%', flex: '1' }}
                        />
                    </div>
                </div>
                <div className="flex flex-grow mt-5 gap-3">
                    <input type="checkbox" name="self image required" id="self image required" className="my-auto" checked={selfImageRequired} onChange={() => setSelfImageRequired(!selfImageRequired)} />
                    <span>Self Image required</span>
                </div>
                {
                    selfImageRequired &&
                    <div className="flex flex-grow mt-1 gap-3">
                        <InputField
                            label={'Penalty For Not Uploading Self Image'}
                            placeholder={'Enter Penalty Points For Not Uploading Self Image'}
                            value={selfImageNotPresentPenaltyPoints || (mediaType === 'video' ? "100" : "50")}
                            onChange={e => setselfImageNotPresentPenaltyPoints(e.target.value)}
                            type={'number'}
                            required={active}
                        />
                    </div>
                }
            </div>
        );
    }
}

export default SubmissionType;